import { FONT_SIZE, SECONDARY_RED } from "@/theme";

import styled from "styled-components";

export const ErrorMessage = styled.div`
  bottom: 2px;
  color: ${SECONDARY_RED.DEFAULT};
  font-size: ${FONT_SIZE.XS};
  position: absolute;
`;